export const getHtmlAnchorProps = ({ download = false, href = '', onClick = () => { }, rel = '', target = '_self', }) => ({
    download,
    href,
    onClick,
    rel,
    target,
});
